module.exports = __webpack_public_path__ + "static/media/arrow-down-grey.c0dedd2f.svg";